import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import _, { uniqBy } from "lodash";
import { ExcelRenderer } from "react-excel-renderer";
import { Button, Upload } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";

import * as actions from "../../store/actions/index";

import Breadcrumb from "../../components/Breadcrumb";
import UserDromoUploader from "../../components/DromoUploader/User/UserDromoUploader";
import { formatMobileNumber, APP_LIST } from "../Users/utils/utils";
import BulkUserFormElement from "../../components/BulkCreation/BulkUserCreation/BulkUserFormElement";

import { useGetUserHotels } from "../../hooks/user.hooks";
import { useGetRoles } from "../../hooks/roles.hook";
import { useGetAllApplications } from "../../hooks/applications.hooks";
import { useGetAllApplicationRolesData } from "../../hooks/applicationRoles.hook";

const TEMPLATE_PATH = `/excel-template/bulk_user_creation${
  process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT" ? "(marriott)" : ""
}.xlsx`;

const preprocessHmgData = (dataArray) => {
  return uniqBy(
    dataArray.map((el) => ({
      _id: el.hmg_id,
      hmg_name: el.hmg_name,
    })),
    "_id",
  );
};

const sortMainRoleData = (dataArray) => {
  return uniqBy(
    dataArray.map((el) => ({
      _id: el?.main_role_id?._id,
      main_role_name: el?.main_role_id?.main_role_name,
    })),
    "_id",
  )
    .filter((element) => element._id !== undefined)
    .sort((a, b) =>
      a?.main_role_name
        ?.toLowerCase()
        .localeCompare(b?.main_role_name?.toLowerCase()),
    );
};

const APP_NAMES = APP_LIST.map((item) => item.app_name);

const BulkUserCreation = (props) => {
  const [dromoData, setDromoData] = useState(null);
  const [smMappedRoles, setsmMappedRoles] = useState(null);
  const [sortedMainRoles, setSortedMainRoles] = useState(null);
  const [fileList, setFileList] = useState(null);

  const { data: userHotels, isLoading: isUserHotelsLoading } = useGetUserHotels(
    props.api?.smData?.data?._id,
  );
  const { data: adminRoles, isLoading: isAdminRolesLoading } = useGetRoles({
    enabled: props.api?.permission?.sm_solution_access,
  });

  const { data: applications, isLoading: isLoadingApplications } = useGetAllApplications({});
  const { data: applicationRoles, isLoading: isLoadingAppRoles } = useGetAllApplicationRolesData({});

  useEffect(() => {
    if (
      isAdminRolesLoading ||
      isUserHotelsLoading ||
      isLoadingApplications ||
      isLoadingAppRoles
    ) {
      props.apiStart();
    } else {
      props.apiComplete();
    }
  }, [isAdminRolesLoading, isUserHotelsLoading]);

  useEffect(() => {
    if (userHotels) {
      const fetchData = async () => {
        const smUserManagement = props.api?.permission?.sm_user_managment;
        const smSolutionAccess = props.api?.permission?.sm_solution_access;
        let mainRoleSet = [];
        if (smUserManagement) {
          const hmgDataSet = preprocessHmgData(userHotels);
          const hmgApiList = hmgDataSet.length > 0 ? hmgDataSet : [];
          const APIresult = await Promise.all(
            hmgApiList.map(async (hmg) => {
              const retrievedRoles = await props.rolesGetMappedtoHMG(hmg._id);
              return retrievedRoles;
            }),
          );
          mainRoleSet = uniqBy(APIresult.flat(), "_id");
        } else if (smSolutionAccess) {
          mainRoleSet = adminRoles?.data;
        }
        mainRoleSet.sort((a, b) =>
          a?.role_name
            ?.toLowerCase()
            .localeCompare(b?.role_name?.toLowerCase()),
        );

        const processedMainRoles = sortMainRoleData(mainRoleSet);

        setsmMappedRoles(mainRoleSet);
        setSortedMainRoles(processedMainRoles);
      };
      fetchData();
    }
  }, [userHotels]);

  useEffect(() => {
    const smUserManagement = props.api?.permission?.sm_user_managment;
    const smSolutionAccess = props.api?.permission?.sm_solution_access;

    if (!(smUserManagement || smSolutionAccess)) {
      props.history.push("/");
    }
  }, []);

  const resultsHandler = (data, applist, appRoleList) => {
    const updatedData = data;
    if (updatedData && updatedData.length > 0) {
      for (let i = 0; i < data.length; i++) {
        updatedData[i]._id = (i + 1).toString();
        updatedData[i].mobile = formatMobileNumber(updatedData[i].mobile);
        applist.filter(rk=>APP_NAMES.includes(rk.app_name)).forEach(apprecord => {
          const applicationRole = appRoleList.find(appRole=>appRole.role_name === updatedData[i][apprecord.app_name] && appRole.app_id ===apprecord._id)
          updatedData[i][apprecord._id] = applicationRole?._id ?? null;
          delete updatedData[i][apprecord.app_name];
        })
        
      }
      setDromoData(updatedData);
    }
  };

  // FIXME: need to remove
  const excelPreprocess = (data) => {
    data.two_factor_authentication = data.two_factor_authentication === "Yes";
    data.mobile = formatMobileNumber(data.mobile);
    applications
      .filter((rk) => APP_NAMES.includes(rk.app_name))
      .forEach((apprecord) => {
        const applicationRole = applicationRoles.find(
          (appRole) =>
            appRole.role_name === data[apprecord.app_name] &&
            appRole.app_id === apprecord._id,
        );
        data[apprecord._id] = applicationRole?._id ?? null;
        delete data[apprecord.app_name];
      });
    return data;
  };

  const beforeUpload = (event) => {
    let fileObj = event;

    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        const sendData = [];

        if (resp && resp.rows) {
          let countOne = 0;
          let indexs = [];

          resp.rows.forEach((a) => {
            if (countOne == 0) {
              indexs = a;
            } else {
              let countTwo = 0;
              const sendObject = {};
              sendObject._id = countOne.toString();
              indexs.forEach((b) => {
                sendObject[b] = a[countTwo];
                countTwo++;
              });
              excelPreprocess(sendObject);
              sendData.push(sendObject);
            }
            countOne++;
            // console.log(indexs, "indexs");
          });
        }
        // console.log(sendData, "sendData");
        // console.log(resp);
        // this.setState({
        //   cols: resp.cols,
        //   rows: resp.rows,
        //   dromoData: sendData,
        // });
        console.log(sendData, "sendData")
        setDromoData(sendData);
        return false;
      }
    });
    return false;
  };

  // FIXME: need to remove
  const handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(fileList);
  };

  const uploadButton = useMemo(() => {
    return process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT" ? (
      <div style={{ marginBottom: "20px" }}>
        <Upload
          beforeUpload={beforeUpload}
          onChange={handleChange}
          accept=".xlsx"
          name="file"
          fileList={fileList}
        >
          <Button>
            <UploadOutlined />
            Click to Upload
          </Button>
        </Upload>
      </div>
    ) : (
      <UserDromoUploader
        resultsHandler={(function (apps, roles) {
          return function (e) {
            resultsHandler(e, apps, roles);
          };
        })(applications, applicationRoles)}
      />
    )
  }, [applications, applicationRoles])

  return (
    <div>
      <div className="container_aa">
        <h3>Bulk User Creation</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            {
              path: "/bulk-user-creation",
              breadcrumbName: "Bulk User Creation",
            },
          ]}
        />
      </div>

      <div className="container_ab">
        <div className="container_style_1 user_manager">
          <div className="container_style_1_b" style={{ width: "100%" }}>
            <div style={{ marginBottom: "20px" }}>
              <Button
                href={TEMPLATE_PATH}
                type="primary"
                shape="round"
                icon={<DownloadOutlined />}
                size="middle"
              >
                Download Template
              </Button>
            </div>
            {!isAdminRolesLoading &&
            !isUserHotelsLoading &&
            !isLoadingApplications &&
            !isLoadingAppRoles
              ? uploadButton
              : null}
            {dromoData && userHotels && smMappedRoles && sortedMainRoles && (
              <BulkUserFormElement
                hotelList={userHotels}
                mappedRoles={smMappedRoles}
                mainRoles={sortedMainRoles}
                userData={dromoData}
                applications={applications}
                applicationRoles={applicationRoles}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  rolesGetMappedtoHMG: (data) => dispatch(actions.rolesGetMappedtoHMG(data)),
  apiStart: () => dispatch(actions.apiStart()),
  apiComplete: () => dispatch(actions.apiComplete()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkUserCreation);
